import type { IDTRole } from '@seen/core/models/care-teams/constants'
import { type ReactNode, useMemo } from 'react'
import { PractitionerOption } from '#src/components/options/PractitionerOption.tsx'
import { UserPlaceholderOption } from '#src/components/options/UserPlaceholderOption.tsx'
import { usePractitionersInternal } from '#src/hooks/usePractitionersInternal.ts'

export function useOwnerComboboxOptions(
  selectedValue: string | null | undefined,
  idtRoles?: readonly IDTRole[]
): { value: string | null; label: ReactNode; keywords: string[] }[] {
  const practitioners = usePractitionersInternal(idtRoles)
  const options = useMemo(
    () => [
      {
        value: null,
        label: (
          <UserPlaceholderOption isSelected={!selectedValue}>
            No owner
          </UserPlaceholderOption>
        ),
        keywords: ['No owner'],
      },
      ...practitioners.map((p) => ({
        value: p.reference.reference,
        label: (
          <PractitionerOption
            practitioner={p.reference}
            isSelected={p.reference.reference === selectedValue}
            isPreferred={p.isPreferred}
          />
        ),
        keywords: p.searchKeywords,
        boost: p.isPreferred ? 1 : 0,
      })),
    ],
    [practitioners, selectedValue]
  )
  return options
}
